import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { capitalize } from "@mui/material";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { getResourceSizeColumnDef } from "../common/getResourceSizeColumnDef";
import { FilteredLambdaResourceItem } from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { TypographyWithCopy } from "@/components/common/TypographyWithCopy";
import { getResourceMetricsColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceMetricsColumnDef";
import { getResourceCreationTimeColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceCreationTimeColumnDef";
import { resourceCreatedByColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/resourceCreatedByColumnDef";

export const lambdaColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef(),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getResourceCreationTimeColumnDef("Creation Date"),

  {
    field: "resource.architecture",
    headerName: "Architecture",
    cellRenderer: ({
      data,
    }: ICellRendererParams<FilteredLambdaResourceItem>) => {
      const value = data?.resource?.architecture;

      if (!value) {
        return "-";
      }

      return <TypographyWithCopy value={capitalize(value)} />;
    },
  },

  getResourceSizeColumnDef({
    propName: "compute",
    headerName: "Compute",
  }),

  getResourceMetricsColumnDef(
    "Total Compute Usage Max",
    "total_compute_usage",
    "lambda",
  ),

  getResourceMetricsColumnDef("Requests Sum", "requests_sum", "lambda"),

  getResourceMetricsColumnDef(
    "Provisioned Concurrency Usage Sum",
    "provisioned_concurrency_usage_sum",
    "lambda",
  ),

  getResourceSizeColumnDef({
    propName: "provisioned_storage",
    headerName: "Provisioned Storage",
  }),

  {
    field: "resource.provisioned_concurrency",
    headerName: "Provisioned Concurrency",
  },

  resourceCreatedByColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,

  jiraIssuesColumnDef,
];
